var _require = require('sequelize'),
    DataTypes = _require.DataTypes;

function User(sequelize) {
  return sequelize.define('users', {
    id: {
      type: DataTypes.UUID,
      defaultValue: DataTypes.UUIDV4,
      primaryKey: true,
      allowNull: false
    },
    email: {
      type: DataTypes.STRING,
      unique: true,
      allowNull: false
    },
    password: {
      type: DataTypes.STRING,
      allowNull: false
    },
    generatedOTP: {
      type: DataTypes.STRING,
      allowNull: true,
      field: 'generatedOTP'
    },
    isValidated: {
      type: DataTypes.BOOLEAN,
      defaultValue: false,
      allowNull: false,
      field: 'isValidated'
    },
    salt: {
      type: DataTypes.STRING,
      allowNull: false
    },
    coupon_code: {
      type: DataTypes.STRING,
      allowNull: true
    }
  });
}

module.exports = User;